// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"888":"6f524d6128e80257","913":"74097d372e3ece5a"}[chunkId] + ".css";
};